<template>
  <div>
    <div
      class="active-content"
      :style="
        bgshow
          ? `background-image:url(${trueImgUrl})`
          : `background-image:url(${falseImgUrl})`
      "
    >
      <div
        class="gotoyunq-box"
        :style="bgshow ? `top: 6.027rem;` : `top: 5.547rem;`"
      >
        <button class="gotoyunq" @click="gotoindex">进入移动云擎</button>
      </div>
    </div>
    <div class="footer">
      <div class="footer-title"></div>
      <div class="footer-content">
        <div class="computer">
          <div class="computer-content">
            <span class="computer-icon"></span>
            <span class="computer-next"></span>
          </div>
          <div class="computer-word">电脑输入网址 www.holywiser.com</div>
        </div>
        <div class="weichat">
          <div>
            <span class="weichat-icon"></span>
            <span class="weichat-next"></span>
          </div>
          <div class="weichat-word">
            <span>打开微信</span><br />
            <span> 扫码登录</span>
          </div>
        </div>
        <div class="index">
          <div>
            <span class="index-icon"></span>
          </div>
          <div class="index-word">
            <span>进入</span><br />
            <span>众智云擎</span>
          </div>
        </div>
      </div>
    </div>
    <div class="mianze">
      本活动最终解释权归众智云擎所有
    </div>
  </div>
</template>
<script>
import falseImgUrl from "@/assets/active/hongbao@3x.png";
import trueImgUrl from "@/assets/active/hongbaotrue@3x.png";
export default {
  props: ["bgshow"],
  data() {
    console.log(this.bgshow);
    return {
      falseImgUrl,
      trueImgUrl,
    };
  },
  methods: {
    gotoindex() {
      this.$router.push("/");
    },
  },
};
</script>
<style lang="less" scope>
.active-content {
  position: relative;
  margin-left: 50%;
  transform: translateX(-50%);
  width: 297px;
  height: 300px;
  background-repeat: no-repeat;
  background-size: contain;
  .gotoyunq-box {
    position: absolute;
    width: 194px;
    height: 44px;
    left: 50%;
    transform: translateX(-50%);
  }
  .gotoyunq {
    position: absolute;
    width: 194px;
    height: 44px;
    top: 0;
    font-size: 19px;
    color: #7d5635;
    font-weight: bold;
    border: transparent;
    background: linear-gradient(180deg, #fcd6b1, #fedec0, #efa96c);
    box-shadow: 0px 3px 5px 0px rgba(127, 28, 26, 0.56),
      0px -2px 1px 0px rgba(254, 233, 193, 0.2);
    border-radius: 20px;
    animation: activetwo 0.5s infinite cubic-bezier(0, 0.08, 0, 0.94);
  }
}
.footer {
  position: relative;
  margin-left: 50%;
  transform: translateX(-50%);
  width: 327px;
  height: 146px;
  background: url(../../../assets/active/img-beijing@3x.png) no-repeat;
  background-size: contain;
  .footer-title {
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    width: 148px;
    height: 16px;
    background: url(../../../assets/active/img-biaoti@3x.png) no-repeat;
    background-size: contain;
  }
  .footer-content {
    display: flex;
    position: absolute;
    top: 44px;
    width: 100%;
    height: 82px;
    padding: 0 13px;
    .computer {
      position: relative;
      width: 114px;
      height: 100%;
      margin-right: 27px;
      .computer-icon {
        position: absolute;
        left: 36px;
        width: 42px;
        height: 42px;
        background: url(../../../assets/active/img-diannao@3x.png) no-repeat;
        background-size: contain;
      }
      .computer-next {
        position: absolute;
        right: 0px;
        top: 16px;
        width: 12px;
        height: 12px;
        background: url(../../../assets/active/img-xiayibu@3x.png) no-repeat;
        background-size: contain;
      }
      .computer-word {
        position: absolute;
        bottom: 0;
        color: #fff;
        text-align: center;
        font-size: 12px;
        color: #ffbaa2;
      }
    }
    .weichat {
      position: relative;
      width: 78px;
      height: 100%;
      margin-right: 30px;
      .weichat-icon {
        position: absolute;
        left: 6px;
        width: 42px;
        height: 42px;
        background: url(../../../assets/active/img-weixin@3x.png) no-repeat;
        background-size: contain;
      }
      .weichat-next {
        position: absolute;
        right: 0px;
        top: 16px;
        width: 12px;
        height: 12px;
        background: url(../../../assets/active/img-xiayibu@3x.png) no-repeat;
        background-size: contain;
      }
      .weichat-word {
        position: absolute;
        bottom: 0;
        width: 50px;
        color: #fff;
        text-align: center;
        font-size: 12px;
        color: #ffbaa2;
      }
    }
    .index {
      position: relative;
      width: 48px;
      height: 100%;
      .index-icon {
        position: absolute;
        left: 4px;
        width: 42px;
        height: 42px;
        background: url(../../../assets/active/img-logo@3x.png) no-repeat;
        background-size: contain;
      }
      .index-word {
        position: absolute;
        bottom: 0;
        width: 50px;
        color: #fff;
        text-align: center;
        font-size: 12px;
        color: #ffbaa2;
      }
    }
  }
}
.mianze {
  margin-top: 20px;
  color: #ffbaa2;
  font-size: 12px;
  text-align: center;
}
@keyframes activetwo {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}
</style>
